export enum OfficeInventoryMenuEnum {
    overview = 0,
    neighborhood,
    properties
}
